import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const FloatingActionButton = ({ onClick, className = "" }) => {
  return (
    <Button
      variant="default"
      size="lg"
      onClick={onClick}
      className={`
        fixed bottom-6 right-6 z-[900] w-14 h-14 rounded-full shadow-soft-lg
        bg-primary hover:bg-primary/90 text-primary-foreground
        flex items-center justify-center transition-all duration-200
        hover:scale-110 active:scale-95
        ${className}
      `}
      aria-label="Quick log symptoms"
    >
      <Icon name="Plus" size={24} color="currentColor" />
    </Button>
  );
};

export default FloatingActionButton;